import StandardModal from 'modals/StandardModal';

const ImageModal = ({ options }) => {
	return (
		<StandardModal title={''} closeOnOutsideClick size="xl">
			<div className="text-center image-modal-wrapper">
				<img className="street-view-image w-100" src={options.src} alt="alt" />
				{options.copyRight && (
					<div className="position-relative">{options.copyRight}</div>
				)}
			</div>
		</StandardModal>
	);
};

export default ImageModal;
